import { render, staticRenderFns } from "./CardExpander.vue?vue&type=template&id=1ebd7e84&scoped=true&"
import script from "./CardExpander.vue?vue&type=script&lang=ts&"
export * from "./CardExpander.vue?vue&type=script&lang=ts&"
import style0 from "./CardExpander.vue?vue&type=style&index=0&id=1ebd7e84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebd7e84",
  null
  
)

export default component.exports